import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchForm from "../components/SearchForm";
import {browserHistory} from "react-router";
import i18n from 'i18next';
import { fetchOptimalles, setSelectedHike, setSelectedTheme, setConfirmed, setDateRange } from '../../data/actions/optimalle'
import {isEmpty} from "lodash";

class SearchFormContainer extends Component {
    static propTypes = {
        fetchOptimalles: PropTypes.func,
        setSelectedTheme: PropTypes.func,
        setSelectedHike: PropTypes.func,
        setConfirmed: PropTypes.func,
        setDateRange: PropTypes.func,
        selectedHike: PropTypes.string,
        selectedTheme: PropTypes.string
    };

    componentDidUpdate(prevProps) {

        if (prevProps.selectedTheme !== this.props.selectedTheme || prevProps.selectedHike !== this.props.selectedHike) {
            const {selectedTheme, selectedHike} = this.props;
            let theme = selectedTheme == 'itineraires' ? null : selectedTheme;
            if (!isEmpty(theme) && !isEmpty(selectedHike)) {
                this.props.setSelectedHike(selectedHike)
                    .then(()=> this.props.setSelectedTheme(theme))
                    .then(() => this.refreshOptimalles())
            } else if (!isEmpty(theme)) {
                this.handleChangeTheme(theme)
            }
        }
    }

    refreshOptimalles = () => {
        this.props.fetchOptimalles()
    }

    handleChangeTheme = (theme) => {
        this.props.setSelectedHike(null)
        if(theme != 'null' && theme != 'itineraires') {
            this.props.setSelectedTheme(theme)
            browserHistory.push(`/${i18n.language}/optimalles/${theme}`)
        } else {
            this.props.setSelectedTheme(null)
            browserHistory.push(`/${i18n.language}/optimalles`)
        }
        this.refreshOptimalles()
    }

    handleChangeHike = (hike) => {
        let theme = this.props.filters.theme ? this.props.filters.theme : 'itineraires';
        if(hike != 'null') {
            this.props.setSelectedHike(hike)
            browserHistory.push(`/${i18n.language}/optimalles/${theme}/${hike}`)
            this.refreshOptimalles()
        } else {
            this.handleChangeTheme(this.props.filters.theme)
        }
    }

    handleChangeConfirmation = (event) => {
        this.props.setConfirmed(event.target.checked)
        this.refreshOptimalles()
    }

    handleChangeDateRange = (range) => {
        this.props.setDateRange(range)
        this.refreshOptimalles()
    }

    render() {

        const {hike, theme, from, to} = this.props.filters;
        const {isLoading} = this.props;

        return (
            <SearchForm
                theme={theme}
                hike={hike}
                from={from}
                to={to}
                isLoading={isLoading}
                onThemeChanged={::this.handleChangeTheme}
                onHikeChanged={::this.handleChangeHike}
                onConfirmedChanged={::this.handleChangeConfirmation}
                onDateRangeChanged={::this.handleChangeDateRange}
            >
            </SearchForm>
        );
    }
}

export default connect(
    state => ({
        filters: state.filters,
        isLoading: state.isFetching
    }),
    dispatch => bindActionCreators({ fetchOptimalles, setSelectedHike, setSelectedTheme, setConfirmed, setDateRange }, dispatch)
)(SearchFormContainer);